import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RingCentralExportConnectionDetails, RingCentralExportRef } from '../../../shared/models/generated/ziroModels';
import { Observable } from 'rxjs';
import { FileDownloadService } from '../../../shared/services/file-download.service';

@Injectable()
export class MigrationsRingCentralResource {
  private _http = inject(HttpClient);
  private _fileDownloadService = inject(FileDownloadService);

  validate(tenantId: string, body: RingCentralExportConnectionDetails): Observable<void> {
    return this._http.post<void>(
      `/services/microsoft/migrations/tenants/${tenantId}/exports/ring-central/validation`,
      body,
    );
  }

  post(tenantId: string, body: RingCentralExportConnectionDetails): Observable<RingCentralExportRef> {
    return this._http.post<RingCentralExportRef>(
      `/services/microsoft/migrations/tenants/${tenantId}/exports/ring-central`,
      body,
    );
  }

  delete(tenantId: string, exportId: string): Observable<void> {
    return this._http.delete<void>(
      `/services/microsoft/migrations/tenants/${tenantId}/exports/ring-central/${exportId}`,
    );
  }

  downloadFiles(tenantId: string, exportId: string): Observable<void> {
    return this._fileDownloadService.downloadFile(
      `/services/microsoft/migrations/tenants/${tenantId}/exports/ring-central/${exportId}/download`,
      'get',
    );
  }
}
